
import { MoveLeft, AlertCircle } from "lucide-react"
import { Link } from "react-router-dom"
import { Button } from "@/shared/ui/button.tsx"

export default function NotFound() {
  return (
    <div className="flex flex-col items-center justify-center min-h-[100dvh] px-4 text-center bg-background">
      <div className="space-y-6 max-w-md mx-auto">
        <div className="space-y-2">
          <div className="flex justify-center">
            <div className="rounded-full bg-muted p-4 text-primary">
              <AlertCircle className="h-12 w-12" />
            </div>
          </div>
          <h1 className="text-4xl font-bold tracking-tighter sm:text-5xl">404</h1>
          <h2 className="text-2xl font-semibold">Page not found</h2>
          <p className="text-muted-foreground">
            Sorry, we couldn't find the page you're looking for. It might have been moved, deleted, or never existed.
          </p>
        </div>
        <div className="flex flex-col sm:flex-row gap-2 justify-center">
          <Button asChild>
            <Link to="/">
              <MoveLeft className="mr-2 h-4 w-4" />
              Back to home
            </Link>
          </Button>
        </div>
      </div>
    </div>
  )
}
